import { render, staticRenderFns } from "./EstatusListadeEspera.vue?vue&type=template&id=060acd72&scoped=true"
import script from "./EstatusListadeEspera.vue?vue&type=script&lang=js"
export * from "./EstatusListadeEspera.vue?vue&type=script&lang=js"
import style0 from "./EstatusListadeEspera.vue?vue&type=style&index=0&id=060acd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060acd72",
  null
  
)

export default component.exports